import { Controller } from "@hotwired/stimulus";

// 購入申請拒否モーダルの制御を行うStimulusコントローラー
export default class extends Controller {
  connect() {
    $("#confirmRejectModal").on("show.bs.modal", this.#show);
  }

  disconnect() {
    $("#confirmRejectModal").off("show.bs.modal", this.#show);
  }

  #show = () => {
    const reasonText = $("#rejectReasonText");
    const modalReasonText = $("#confirmRejectModalReasonText");

    const reason = reasonText.val();
    modalReasonText.val(reason);
  };
}
